import { ColorPickerField } from '../components/ColorPickerField';
import numberedSubSectionPlugin from './numberedSubSectionPlugin';

const numberedSectionPlugin: any = {
  Renderer: ({ data, children }: any) => (
    <div className="numbered-section flex-col" id={data?.linkId}>
      <div className="flex numbered-section-title-container ai-center">
        <h2
          className="numbered-section-index"
          style={{
            backgroundColor: data?.backgroundColor
              ? data?.backgroundColor
              : 'rgba(119,119,119,1)',
            color: data?.numberingColor
              ? data?.numberingColor
              : 'rgba(44, 56, 126,1)',
          }}
        >
          #.
        </h2>
        <h2
          style={{
            color: data?.titleColor ? data?.titleColor : 'rgba(44, 56, 126,1)',
          }}
          className="numbered-section-title"
        >
          {data?.sectionTitle ? data?.sectionTitle : 'Section Title'}
        </h2>
        {/* <FaClipboardList
          size={22}
          color={
            data?.backgroundColor
              ? data?.backgroundColor
              : 'rgba(119,119,119,1)'
          }
          className="pointer section-link"
          style={{ marginLeft: 5 }}
          title="Copy Section Link"
          onClick={() => {
            if (data?.linkId) {
              let docStr = localStorage.getItem('AdminActiveDocument');
              let docSlug;
              if (docStr) {
                docSlug = JSON.parse(docStr).slug;
                const copyText = 'document:' + docSlug + '#' + data?.linkId;
                navigator.clipboard.writeText(copyText);
                alert('Copied section link!');
              }
            } else {
              alert('Please enter a link id');
            }
          }}
        /> */}
      </div>
      <div className="numbered-section-content">{children}</div>
    </div>
  ),
  createInitialChildren: () => {
    return [
      [
        {
          plugin: numberedSubSectionPlugin,
        },
      ],
    ];
  },
  id: 'numberedSectionPlugin',
  title: 'Numbered Section',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      properties: {
        sectionTitle: { type: 'string', default: '' },
        linkId: { type: 'string', default: '' },
        backgroundColor: {
          type: 'string',
          default: 'rgba(119,119,119,1)',
          uniforms: {
            component: ColorPickerField,
            label: 'Background Color:',
          },
        },
        numberingColor: {
          type: 'string',
          default: 'rgba(44,56,126,1)',
          uniforms: {
            component: ColorPickerField,
            label: 'Numbering color:',
          },
        },
        titleColor: {
          type: 'string',
          default: 'rgba(44,56,126,1)',
          uniforms: {
            component: ColorPickerField,
            label: 'Title Color:',
          },
        },
      },
    },
  },
};

export default numberedSectionPlugin;
